import * as z from "zod";

const ACCEPTED_IMAGE_TYPES = [
  "image/jpg",
  "image/png",
  "image/jpeg",
  undefined,
  null,
];

export const TenantFormRule = z.object({
  owner: z.string().optional(),
  businessName: z.string().optional(),
  businessType: z.string().optional(),
  description: z.string().optional(),
  avatar: z.string().optional(),
  email: z.string().optional(),
  mobileNumber: z.string().optional(),
  phoneNumber: z.string().optional(),
  website: z.string().optional(),
  membershipDate: z.coerce.date().optional().nullish().or(z.string().max(0)),
  rewardsType: z.string().optional(),
  slug: z.string().optional(),
  postRegistrationLink: z.string().optional(),
});
export const RoleFormRule = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});
export const PersonFormRule = z.object({
  tenant: z.string().optional(),
  role: z.string().optional(),
  firstName: z.string().optional(),
  middleName: z.string().optional(),
  lastName: z.string().optional(),
  username: z.string().optional(),
  email: z.string().optional(),
  password: z.string().optional(),
  isVerified: z.boolean().optional(),
  avatar: z.string().optional(),
  activationCode: z.string().optional(),
  gender: z.string().optional(),
  birthday: z.coerce.date().optional().nullish().or(z.string().max(0)),
  isBlocked: z.boolean().optional(),
  mobileNumber: z.string().optional(),
  fatherName: z.string().optional(),
  motherName: z.string().optional(),
  emergencyContact_1Number: z.string().optional(),
  emergencyContact_1Name: z.string().optional(),
  emergencyContact_1Relationship: z.string().optional(),
  emergencyContact_2Number: z.string().optional(),
  emergencyContact_2Name: z.string().optional(),
  emergencyContact_2Relationship: z.string().optional(),
  sss: z.string().optional(),
  philhealth: z.string().optional(),
  pagibig: z.string().optional(),
  tin: z.string().optional(),
  medicalCondition: z.string().optional(),
  bloodType: z.string().optional(),
  elementary: z.string().optional(),
  highSchool: z.string().optional(),
  college: z.string().optional(),
  postCollege: z.string().optional(),
  undergraduate: z.string().optional(),
  curriculumVitae: z.string().optional(),
  supportingDoc: z.string().optional(),
  intentLetter: z.string().optional(),
  applicationLetter: z.string().optional(),
  photo: z
    .any()
    .optional()
    .refine(
      (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
      "Only .jpg, .jpeg, and .png formats are supported."
    ),
});
export const TransportTypeFormRule = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});
export const UtilTransportLocationFormRule = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});
export const UtilActivityTypeFormRule = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});
export const LocationFormRule = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});
export const ClientFormRule = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  address: z.string().optional(),
  city: z.string().optional(),
  province: z.string().optional(),
  contactNumber: z.string().optional(),
});
export const AgentFormRule = z.object({
  code: z.string().optional(),
  name: z.string().optional(),
  email: z.string().optional(),
  address: z.string().optional(),
  contactNumber: z.string().optional(),
  markupPercentage: z.number().optional(),
});
export const HotelFormRule = z.object({
  // roomType: z.string().optional(),
  code: z.string().optional(),
  name: z.string().optional(),
  withBreakfast: z.union([z.boolean(), z.number()]).optional(),
  location: z.string().optional(),
  description: z.string().optional(),
});
export const RoomTypeFormRule = z.object({
  hotel: z.string().optional(),
  validFrom: z.string().optional(),
  validUntil: z.string().optional(),
  name: z.string().optional(),
  price: z.number().optional(),
});
export const ActivityFormRule = z.object({
  location: z.string().optional(),
  activityType: z.string().optional(),
  name: z.string().optional(),
  description: z.string().optional(),
  isChildActivity: z.union([z.boolean(), z.number()]).optional(),
  childRate: z.number().optional(),
  showAsOptional: z.union([z.boolean(), z.number()]).optional(),
  isFree: z.union([z.boolean(), z.number()]).optional(),
  entranceFee: z.number().optional(),
});
export const PackageFormRule = z.object({
  name: z.string().optional(),
  numPeople: z.number().optional().nullable(),
  unit: z.string().optional(),
  sizeDescription: z.string().optional(),
});
export const RatePerPaxFormRule = z.object({
  activity: z.string().optional(),
  number: z.number().optional(),
  childRate: z.number().optional(),
  // seniorRate: z.number().optional(),
  sizeDescription: z.string().optional(),
  amount: z.number().optional(),
  totalAmount: z.number().optional(),
});
export const PackageActivityFormRule = z.object({
  package: z.string().optional(),
  activity: z.string().optional(),
});
export const QuoteActivityFormRule = z.object({
  code: z.string().optional(),
  baseActivity: z.string().optional(),
  quotation: z.string().optional(),
  isModified: z.union([z.boolean(), z.number()]).optional(),
  name: z.string().optional(),
  description: z.string().optional(),
  day: z.number().optional(),
  isChildActivity: z.union([z.boolean(), z.number()]).optional(),
  childRate: z.number().optional(),
  showAsOptional: z.union([z.boolean(), z.number()]).optional(),
  isFree: z.union([z.boolean(), z.number()]).optional(),
  entranceFee: z.number().optional(),
  numPeople: z.number().optional().nullable(),
  unit: z.string().optional().nullable(),
  ratePerPax: z.string().optional(),
  amount: z.number().optional(),
});
export const QuoteTransportChildrenFormRule = z.object({
  code: z.string().optional(),
  quotation: z.string().optional(),
  quoteTransport: z.string().optional(),
  ageBracket: z.string().optional(),
  childPricePerPax: z.number().optional(),
  numChildren: z.number().optional(),
  amount: z.number().optional(),
});
export const QuoteTransportFormRule = z.object({
  code: z.string().optional(),
  description: z.string().optional(),
  quotation: z.string().optional(),
  transportType: z.string().optional(),
  transportTypeName: z.string().optional(),
  fromLocation: z.string().optional(),
  fromLocationName: z.string().optional(),
  toLocation: z.string().optional(),
  toLocationName: z.string().optional(),
  pricePerPax: z.number().optional(),
  numPeople: z.number().optional(),
  unit: z.string().optional().nullable(),
  amount: z.number().optional(),
  childrenTotal: z.number().optional(),
  childPrices: z.array(QuoteTransportChildrenFormRule).optional(),
});
export const QuoteAccommodationFormRule = z.object({
  code: z.string().optional(),
  description: z.string().optional(),
  night: z.number().optional(),
  quotation: z.string().optional(),
  hotel: z.string().optional(),
  hotelName: z.string().optional(),
  roomType: z.string().optional(),
  roomTypeName: z.string().optional(),
  numPeople: z.number().optional(),
  unit: z.string().optional(),
  validFrom: z.string().optional(),
  validUntil: z.string().optional(),
  name: z.string().optional(),
  price: z.number().optional(),
  withBreakfast: z.union([z.boolean(), z.number()]).optional(), // Not used in submission but needed for UI
});

export const QuotationFormRule = z.object({
  basePackage: z.string().optional(),
  basePackageName: z.string().optional(),
  packageName: z.string().optional(),
  client: z.string().optional(),
  clientName: z.string().optional(),
  status: z.string().optional(),
  statusName: z.string().optional(),
  packageInclusions: z
    .array(
      z.object({
        value: z.string(),
      })
    )
    .optional(),
  quotationDate: z.string().optional(),
  location: z.string().optional(),
  locationName: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  numAdults: z.number().optional(),
  numChildren: z.number().optional(),
  numNights: z.number().optional(),
  numDays: z.number().optional(),
  agent: z.string().optional(),
  agentMarkup: z.number().optional(),
  adultRateTotal: z.number().optional(),
  childRateTotal: z.number().optional(),
  amount: z.number().optional(),
  activities: z.array(QuoteActivityFormRule).optional(),
  transport: z.array(QuoteTransportFormRule).optional(),
  accommodation: z.array(QuoteAccommodationFormRule).optional(),
  hideTotal: z.boolean().optional(),
  customRows: z.array(
      z.object({
        display_location: z.string().optional(),
        value: z.string().optional(),
        col_one: z.string().optional(),
        col_two: z.string().optional(),
        col_three: z.string().optional(),
        col_four: z.string().optional(),
      })
  ).optional(),
  customDays: z.array(
      z.object({
        index: z.number().optional(),
        value: z.number().optional(),
        label: z.string().optional(),
      })
  ).optional()
});
export const InvoiceFormRule = z.object({
  baseQuote: z.string().optional(),
  invoiceDate: z.string().optional(),
  dueDate: z.string().optional(),
  amount: z.number().optional(),
  quotation: QuotationFormRule.optional(),
});
export const TravelVoucherFormRule = z.object({
  baseInvoice: z.string().optional(),
  confirmationNum: z.string().optional(),
  paymentCompletion: z.number().optional(),
  isFullyPaid: z.union([z.boolean(), z.number()]).optional(),
  amountPaid: z.number().optional(),
  amount: z.number().optional(),
});
export const PaymentFormRule = z.object({
  voucher: z.string().optional(),
  description: z.string().optional(),
  paymentType: z.string().optional(),
  paymentDate: z.coerce.date().optional().nullish().or(z.string().max(0)),
  amount: z.number().optional(),
});
export const PackageTransportFormRule = z.object({
  package: z.string().optional(),
  transport: z.string().optional(),
  transportType: z.string().optional(),
  fromLocation: z.string().optional(),
  toLocation: z.string().optional(),
  pricePerPax: z.number().optional(),
  numPeople: z.number().optional(),
  unit: z.string().optional(),
  amount: z.number().optional(),
  description: z.string().optional(),
});
export const PackageAccommodationFormRule = z.object({
  package: z.string().optional(),
  night: z.number().optional(),
  hotel: z.string().optional(),
  roomType: z.string().optional(),
  numPeople: z.number().optional(),
  unit: z.string().optional(),
  validFrom: z.string().optional(),
  validUntil: z.string().optional(),
  name: z.string().optional(),
  price: z.number().optional(),
  description: z.string().optional(),
});
export const StatusFormRule = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
});
export const UtilAgeBracketFormRule = z.object({
  type: z.string().optional(),
  name: z.string().optional(),
  price: z.number().optional(),
});
// RULE ADD
export const LoginRule = z.object({
  username: z.string().min(1, "Email/Username is required"),
  password: z.string().min(1, { message: "Password is required" }),
});

export type LoginFormSchema = z.infer<typeof LoginRule>;
export type TenantFormSchema = z.infer<typeof TenantFormRule>;
export type RoleFormSchema = z.infer<typeof RoleFormRule>;
export type PersonFormSchema = z.infer<typeof PersonFormRule>;
export type TransportTypeFormSchema = z.infer<typeof TransportTypeFormRule>;
export type UtilTransportLocationFormSchema = z.infer<
  typeof UtilTransportLocationFormRule
>;
export type UtilActivityTypeFormSchema = z.infer<
  typeof UtilActivityTypeFormRule
>;
export type LocationFormSchema = z.infer<typeof LocationFormRule>;
export type ClientFormSchema = z.infer<typeof ClientFormRule>;
export type AgentFormSchema = z.infer<typeof AgentFormRule>;
export type HotelFormSchema = z.infer<typeof HotelFormRule>;
export type RoomTypeFormSchema = z.infer<typeof RoomTypeFormRule>;
export type ActivityFormSchema = z.infer<typeof ActivityFormRule>;
export type PackageFormSchema = z.infer<typeof PackageFormRule>;
export type QuotationFormSchema = z.infer<typeof QuotationFormRule>;
export type RatePerPaxFormSchema = z.infer<typeof RatePerPaxFormRule>;
export type PackageActivityFormSchema = z.infer<typeof PackageActivityFormRule>;
export type QuoteActivityFormSchema = z.infer<typeof QuoteActivityFormRule>;
export type QuoteTransportFormSchema = z.infer<typeof QuoteTransportFormRule>;
export type QuoteAccommodationFormSchema = z.infer<
  typeof QuoteAccommodationFormRule
>;
export type InvoiceFormSchema = z.infer<typeof InvoiceFormRule>;
export type TravelVoucherFormSchema = z.infer<typeof TravelVoucherFormRule>;
export type PaymentFormSchema = z.infer<typeof PaymentFormRule>;
export type PackageTransportFormSchema = z.infer<
  typeof PackageTransportFormRule
>;
export type PackageAccommodationFormSchema = z.infer<
  typeof PackageAccommodationFormRule
>;
export type StatusFormSchema = z.infer<typeof StatusFormRule>;
export type UtilAgeBracketFormSchema = z.infer<typeof UtilAgeBracketFormRule>;
export type QuoteTransportChildrenFormSchema = z.infer<
  typeof QuoteTransportChildrenFormRule
>;
// SCHEMA ADD
